"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledRouterLink = exports.StyledLink = exports.StyledLinkContainerArrow = exports.StyledLinkContainer = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _reactRouterDom = require("react-router-dom");

var _colors = require("../../utils/colors");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  text-decoration: none;\n  padding-bottom: 0.5em;\n  transition: 0.3s;\n  color: ", ";\n\n  ", ";\n\n  ", ";\n\n  &:hover {\n    cursor: pointer;\n    ", ";\n    svg {\n      fill: ", ";\n    }\n  }\n\n  svg {\n    fill: ", ";\n    opacity: 1;\n    width: 24px;\n    height: 24px;\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  svg {\n    position: relative;\n    left: 10px;\n    height: 16px;\n    fill: ", ";\n    stroke: ", ";\n  }\n\n  svg:nth-child(1) {\n    width: 19px;\n  }\n  svg:nth-child(2) {\n    transition: width 0.3s ease;\n    width: 0px;\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  svg {\n    left: 0;\n    opacity: 0;\n    top: 6px;\n    position: relative;\n    transition: 0.3s;\n    fill: ", ";\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        background-position: 0 1.24em;\n        color: ", ";\n        + svg {\n          left: 10px;\n          opacity: 1;\n          fill: ", ";\n        }\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        + svg {\n          width: 11px;\n        }\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      ", "\n      background-image: ", ";\n      background-position: 0 1.24em;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        ", "\n        background-image: ", ";\n        background-position: 0 1.56em;\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    background-repeat: repeat-x;\n    background-size: 1px 0.112em;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var getLinkColor = function getLinkColor(props, colorType, initialColor) {
  var linkColor;

  if (props.primary) {
    linkColor = props.theme.link[colorType].primary;
  } else if (props.secondary) {
    linkColor = props.theme.link[colorType].secondary;
  } else if (props.tertiary) {
    linkColor = props.theme.link[colorType].tertiary;
  } else {
    linkColor = props.theme.link[colorType].default;
  }

  return initialColor || (0, _colors.normaliseColor)(linkColor, props.theme);
};

var isDefault = function isDefault(props) {
  return !props.primary && !props.secondary && !props.tertiary;
};

var underlineStyle = function underlineStyle(props) {
  var commonBgStyles = (0, _styledComponents.css)(_templateObject());

  if (isDefault(props)) {
    if (props.icon === 'ChevronRight') {
      return (0, _styledComponents.css)(_templateObject2(), commonBgStyles, function () {
        return "linear-gradient(to right, ".concat(getLinkColor(props, 'color', props.underlineColor), ", ").concat(getLinkColor(props, 'color', props.underlineColor), ")");
      });
    }
  }

  var primary = props.primary;

  if (primary) {
    return (0, _styledComponents.css)(_templateObject3(), commonBgStyles, function () {
      return "linear-gradient(to right, ".concat(getLinkColor(props, 'color', props.theme.colors.actionPrimary300), ", ").concat(getLinkColor(props, 'color', props.theme.colors.actionPrimary300), ")");
    });
  }

  return null;
};

var hoverStyle = function hoverStyle(props) {
  // if (isDefault(props) && props.icon==='ChevronRight') {
  if (isDefault(props)) {
    if (props.icon === 'RightArrow') {
      return (0, _styledComponents.css)(_templateObject4());
    }

    if (props.icon === 'ChevronRight') {
      return (0, _styledComponents.css)(_templateObject5(), function () {
        return getLinkColor(props, 'hoverColor', props.hoverColor);
      }, function () {
        return getLinkColor(props, 'color', props.hoverColor);
      });
    }
  }

  if (props.tertiary) {
    return (0, _styledComponents.css)(_templateObject6(), function () {
      return getLinkColor(props, 'hoverColor', props.hoverColor);
    });
  }

  return (0, _styledComponents.css)(_templateObject7(), function () {
    return getLinkColor(props, 'hoverColor', props.hoverColor);
  });
};

var StyledLinkContainer = _styledComponents.default.div(_templateObject8(), function (props) {
  return props.margin && "margin: ".concat(props.margin, ";");
}, function (props) {
  return getLinkColor(props, 'color', props.textColor);
});

exports.StyledLinkContainer = StyledLinkContainer;

var StyledLinkContainerArrow = _styledComponents.default.div(_templateObject9(), function (props) {
  return props.margin && "margin: ".concat(props.margin, ";");
}, function (props) {
  return getLinkColor(props, 'color', props.textColor);
}, function (props) {
  return getLinkColor(props, 'color', props.textColor);
});

exports.StyledLinkContainerArrow = StyledLinkContainerArrow;
var LinkStyles = (0, _styledComponents.css)(_templateObject10(), function (props) {
  return getLinkColor(props, 'color', props.textColor);
}, underlineStyle, function (props) {
  return props.isHover && hoverStyle;
}, hoverStyle, function (props) {
  return getLinkColor(props, 'hoverColor', props.textColor);
}, function (props) {
  return getLinkColor(props, 'color', props.textColor);
});

var StyledLink = _styledComponents.default.a(_templateObject11(), LinkStyles);

exports.StyledLink = StyledLink;
var StyledRouterLink = (0, _styledComponents.default)(_reactRouterDom.Link)(_templateObject12(), LinkStyles);
exports.StyledRouterLink = StyledRouterLink;